import {
    CONFIRM_ADDRESS_START,
    CONFIRM_ADDRESS_SUCCESS,
    CONFIRM_ADDRESS_ERROR,
    FETCH_ADDRESS_START,
    FETCH_ADDRESS_SUCCESS,
    FETCH_ADDRESS_ERROR
} from "Constant/RentalCustomer";
  
const initialState = {
    loading: false,
    data: [],
    address_data: []
};
  
export default function headerDataReducer(
    state = { ...initialState },
    action
) {
    switch (action.type) {
      case CONFIRM_ADDRESS_START:
        return {
          ...state,
          loading: true,
        };
      case CONFIRM_ADDRESS_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CONFIRM_ADDRESS_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      case FETCH_ADDRESS_START:
        return {
          ...state,
          loading: true,
        };
      case FETCH_ADDRESS_SUCCESS:
        return {
          ...state,
          address_data: action.payload,
          loading: false,
        };
      case FETCH_ADDRESS_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
}
  